// extracted by mini-css-extract-plugin
export default {"lots":"lots_lots__CFmu3","lots_header":"lots_lots_header__RYdm6","lots_header_left":"lots_lots_header_left__8Sijl"};